import { CheckCircle2 } from 'lucide-react'

type TalentPoolStepIndicatorProps = {
  stepLabels: string[]
  stepIndex: number
}

export function TalentPoolStepIndicator({
  stepLabels,
  stepIndex,
}: TalentPoolStepIndicatorProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        {stepLabels.map((label, index) => (
          <div key={label} className="flex items-center gap-2">
            <span
              className={`inline-flex h-7 w-7 items-center justify-center rounded-full text-[12px] font-semibold ${
                index <= stepIndex
                  ? 'bg-brand-primary text-white'
                  : 'bg-[#e8e8e8] text-[#999999]'
              }`}
            >
              {index < stepIndex ? <CheckCircle2 className="h-4 w-4" /> : index + 1}
            </span>
            <span
              className={`text-[13px] font-semibold ${
                index <= stepIndex ? 'text-[#222222]' : 'text-[#999999]'
              }`}
            >
              {label}
            </span>
            {index < stepLabels.length - 1 && (
              <div
                className={`mx-2 h-[2px] w-8 ${
                  index < stepIndex ? 'bg-brand-primary' : 'bg-[#e8e8e8]'
                }`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
